"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SearchResultsTextTop = /** @class */ (function (_super) {
    __extends(SearchResultsTextTop, _super);
    function SearchResultsTextTop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchResultsTextTop.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h4", null, "Search Results"),
            React.createElement("div", null, "Listed below are the plans that match your search criteria. Please contact the individual carrier for additional information regarding these plans."),
            React.createElement("br", null),
            React.createElement("div", null, "Click on a particular company name to navigate to the company\u2019s website. Click on a particular premium rate to view additional plan information, such as eligibility requirements and applicable policy fees.To alter this search's criteria and execute a new search, click \"New Search.\" Each column can be sorted by clicking the link in the header of the results table. Companies and rating classes will sort alphabetically and plans will sort lowest rate to highest rate. Page numbers appear in the footer of the results table. If there is more than one page of results, click the page number to navigate to additional results. To export the results to a Microsoft Excel compatible format, click \"Export to Excel\". To print a copy of this page, click the Print icon in your browser.")));
    };
    return SearchResultsTextTop;
}(React.PureComponent));
;
exports.default = SearchResultsTextTop;
//# sourceMappingURL=SearchResultsTextTop.js.map